/**
 * E-mail — validação pragmática, deliberadamente NÃO é a RFC 5322 completa.
 *
 * Exige: exatamente um `@`, parte local não vazia e sem espaços, domínio com ao
 * menos um ponto, rótulos de domínio não vazios e TLD com 2+ letras.
 */

const FORMATO_EMAIL = /^[^\s@]+@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)*\.[A-Za-z]{2,}$/;

/** `trim` + caixa baixa. */
export function normalizarEmail(valor: string): string {
  return valor.trim().toLowerCase();
}

/** Valida o e-mail já normalizado. */
export function validarEmail(valor: string): boolean {
  return FORMATO_EMAIL.test(normalizarEmail(valor));
}
